enum LovesSandboxApiServer {
  Dev = 'dev',
  Qa = 'qa',
}

export { LovesSandboxApiServer };
